import { makeLogger } from '@/utils/logger/logger.ts';
import { formatUUIDForLog } from '@/utils/logger/utils.ts';
import { CONCURRENT_TASK_TYPES, ConcurrentTaskType, TOTAL_TASK_STEPS } from '@/context/house/tasks/types.ts';

const HOUSE_LOGGER_NAME = 'HouseTaskManager';
export const logger = makeLogger(HOUSE_LOGGER_NAME);
// Task step ordering used for standardized log formatting
export const TASK_STEPS = ['queued', 'started', 'documentAccepted', 'refetchBeforeComplete', 'apiConfirmed'] as const;
type TaskStep = (typeof TASK_STEPS)[number];
/**
 * Formats and emits a task-scoped log line with a consistent prefix and step counter.
 * Example: [HouseTaskManager][<uiTaskId>] [Step X of N] message
 */
export const logTask = (
	uiTaskId: string,
	step: TaskStep | number | null,
	level: 'info' | 'warn' | 'error',
	message: string,
) => {
	const stepIndex = typeof step === 'number' ? step : step ? TASK_STEPS.indexOf(step) + 1 : null;

	const parts = [
		`[task-id: ${formatUUIDForLog(uiTaskId)}]`,
		stepIndex ? `[step ${stepIndex}/${TOTAL_TASK_STEPS}]` : null,
		message,
	];

	const output = parts.filter(Boolean).join(' '); // joins only non-null parts
	logger[level](output);
};
// Task type utilities
export const isConcurrentTaskType = (taskType: string): taskType is ConcurrentTaskType => {
	return Object.values(CONCURRENT_TASK_TYPES).includes(taskType as ConcurrentTaskType);
};
